export const FEEDBACK_PILL_CATEGORIES = [
  "chatbot.pill.resultsTakingTooLong",
  "chatbot.pill.notWhatIAsked",
  "chatbot.pill.stillConfused",
  "chatbot.pill.somethingElse",
] as const;

export const AGENT_FEEDBACK_PILL_CATEGORIES = [
  "chatbot.pill.resultsTakingTooLong",
  "chatbot.pill.agentNotHelpful",
  "chatbot.pill.somethingElse",
] as const;

export const FEEDBACK_EXEMPT_PATTERNS = [
  /my name is mira|how can i help you/i,
  /what kind of test/i,
  /i can help you find specific answers/i,
];

export const FEEDBACK_TIMER_AGGRESSIVE_MS = 10000;
export const FEEDBACK_TIMER_NORMAL_MS = 60000;
export const AGENT_CHAT_RETRY_DELAY_MS = 15000;
export const AGENT_NON_RESPONSE_TIMEOUT_MS = 60 * 1000;

export const MESSAGE_MAX_LENGTH = 500;
export const TRUNCATION_CHAR_LIMIT = 600;
export const MAX_PENDING_AGENT_MESSAGES = 5;
export const MAX_AGENT_CONNECTION_FAILURES = 4;
export const USER_REJECTED_HANDOFF = "(USER REJECTED HANDOFF)";
export const TALKDESK_AUTOMATIC_FILTER = "Automatic";
